import React from 'react';
import TagMoveButtons from './TagMoveButtons';
import TagDeleteButton from './TagDeleteButton';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { TagElementsRetrievalData } from '../../../../../../../common/api/tags/tagElementsRetrievalRouteTypes';
import TagRenameField from './TagRenameField';
import TagEditColorButton from './TagEditColorButton';

export type TagEditContentProps = {
    tag: Tag | null;
    tagElements: TagElementsRetrievalData[];
    shareRootPath: ImMNElement[];
    closePopup: () => void;
};

const TagEditContent: React.FC<TagEditContentProps> = (props) => {
    const { tag, closePopup } = props;

    if (!tag) return null;

    return (
        <div className="MobileTagEditContent">
            <TagMoveButtons {...props} />
            <TagDeleteButton {...props} />
            <TagRenameField tag={tag} closePopup={closePopup} />
            <TagEditColorButton tag={tag} />
        </div>
    );
};

export default TagEditContent;
